import { Routes } from '@all-hands-hq/plex-graphql-schema';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import React, { Fragment } from 'react';
import { Route, Switch } from 'react-router-dom';

import { LoggedOutPage, PersonalGmailPage } from './LoggedOutPage';
import { NavBar } from './navigation/NavBar';
import { SignInPage } from './SignInPage';

export const SignInMain = (): React.ReactElement => {
  const classes = useStyles();
  return (
    <Fragment>
      <NavBar />
      <div className={classes.contentWrapper}>
        <div className={classes.content}>
          <Switch>
            <Route path={Routes.LOGGED_OUT_PATH}>
              <LoggedOutPage />
            </Route>
            <Route path={Routes.PERSONAL_GMAIL_PATH}>
              <PersonalGmailPage />
            </Route>
            <Route>
              <SignInPage />
            </Route>
          </Switch>
        </div>
      </div>
    </Fragment>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    contentWrapper: {
      backgroundColor: '#F6F6F6',
    },
    content: {
      display: 'flex',
      flexDirection: 'row',
    },
  })
);
